import { Link, NavLink } from "react-router-dom";

const setActive = ({ isActive }) => (isActive ? "navbar-active" : "aaa");

const Header = () => {
	return (
		<div className="header-page">
			<nav className="navbar navbar-expand-lg navbar-dark bg-white py-3">
				<div className="container">
					<Link className="navbar-brand text-white" to="/">
						<img
							src="../img/logo.png"
							alt=""
							style={{ height: "60px" }}
						/>
					</Link>
					<button
						className="navbar-toggler"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#navbarSupportedContent"
						aria-controls="navbarSupportedContent"
						aria-expanded="false"
						aria-label="Toggle navigation"
					>
						<span className="navbar-toggler-icon"></span>
					</button>
					<div
						className="collapse navbar-collapse"
						id="navbarSupportedContent"
					>
						<ul className="navbar-nav ms-auto mb-2 mb-lg-0">
							<li className="nav-item">
								<NavLink
									className={setActive}
									aria-current="page"
									to="/"
								>
									Anasayfa
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink className={setActive} to="/hakkimda">
									Hakkımızda
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink className={setActive} to="/kose-yazilari">
									Branşlarımız
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink className={setActive} to="/iletisim">
									İletişim
								</NavLink>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</div>
	);
};

export default Header;
